import { apiConfig } from '@yandex-int/k-common/client/api/config';
import { matchPath } from 'react-router-dom';

export const getIsInTeacherShowcase = (pathname: string) => {
    const urls = apiConfig.getStaticUrls();
    return matchPath(pathname, { path: urls.labLibraryTeamMain });
};
